export default __webpack_public_path__ + "static/media/calculator.1a0101f9.svg";